export default {
  badge: 'Test',
  badge_title: 'Restaurant de test',
  notice: 'Ceci est un restaurant de test. Les commandes passées ici sont à des fins de test.',
};
